import React from 'react';
import PropTypes from 'prop-types';

const CheckoutProgress = ({ tabs, goToTab, selectedTab }) => {
  const currentIndex = tabs.findIndex(tab => tab.key === selectedTab);
  return (
    <nav className="flex-1 w-full">
      <ol className="flex flex-[1_1_0] list-none m-0 p-0 w-full md:justify-around lg:mt-3">
        {tabs.map(({ progressTitle: tabTitle, key: tabKey }, index) => {
          const isActive = currentIndex >= index;
          const isCurrentTab = currentIndex === index;

          return (
            <li className="flex-[1_1_20%] min-[560px]:mb-4" key={tabKey}>
              {isActive ? (
                <a
                  className="text-base font-bold block pt-3 pr-2.5 pb-3 pl-0 capitalize max-[500px]:text-sm max-[500px]:font-bold max-[500px]:text-center min-[560px]:pt-4 min-[560px]:pr-2.5 min-[560px]:pb-4 min-[560px]:pl-0 text-brand border-t-4 border-solid border-t-brand"
                  onClick={event => {
                    event.preventDefault();
                    goToTab(tabKey.toLowerCase());
                  }}
                  href={`#${tabKey}`}
                  aria-current={isCurrentTab ? 'page' : undefined}
                >
                  {index + 1}.&nbsp;{tabTitle}
                </a>
              ) : (
                <span className="text-base font-bold [border-top:.25rem_solid_#e6e6e6] text-gray block pt-3 pr-2.5 pb-3 pl-0 capitalize max-[500px]:text-sm max-[500px]:font-bold max-[500px]:text-center min-[560px]:pt-4 min-[560px]:pr-2.5 min-[560px]:pb-4 min-[560px]:pl-0">
                  {index + 1}.&nbsp;{tabTitle}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

CheckoutProgress.propTypes = {
  goToTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      progressTitle: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CheckoutProgress;
